<template>
  <div>
    <v-container id="buffet-table" fluid tag="section">
      <div class="table-desktop">
        <v-simple-table :dark="$store.state.isDarkMode">
          <thead class="table-heading" v-if="!tableOptions.loading">
            <tr>
              <template v-for="(name, i) in tableOptions.tableHeaders">
                <th v-if="name != 'settings' && name != 'check'">
                  {{ $t(name) }}
                </th>
                <th v-else-if="name == 'check'">
                  <v-checkbox class="mx-4 mb-4" v-model="selected_all" :dark="$store.state.isDarkMode"
                    @change="checkSelected" hide-details></v-checkbox>
                </th>
                <th v-else>
                  <dialogTable v-if="headerList != {}" :params="headerList" @header-update="updateHeaders($event)" />
                </th>
              </template>
            </tr>
          </thead>
          <div class="table__spinnerWrapper" v-if="tableOptions.loading">
            <app-spinner></app-spinner>
          </div>
          <v-fade-transition mode="out-in" :group="true" tag="tbody">
            <tr v-for="(item, idx) in tableOptions.tableData" :key="idx" v-show="!tableOptions.loading">
              <td :key="index" v-for="(value, key, index) of castItems(item)">
                <span v-html="accessData(item, index)"></span>
              </td>
              <td :class="{ heightWidth: serverRoute == '/test' }" class="justify-center" v-if="displaySettings">
                <slot name="editFeature" :row="item"></slot>
                <app-table-delete-modal v-if="enableDelete" :tableRecord="item" :serverRoute="serverRoute"
                  @record-deleted="reFetchData(tableOptions.tableMeta.page)" />
              </td>
            </tr>
          </v-fade-transition>
        </v-simple-table>
      </div>
      <div class="table-mobile">
        <v-fade-transition mode="out-in" :group="true">
          <v-card v-for="(item, idx) in tableOptions.tableData" :key="'mobile-' + idx" class="pa-3 mb-3 entry-card">
            <v-row dense>
              <v-col cols="12" v-for="(name, i) in tableOptions.tableHeaders" :key="i"
                v-if="name !== 'settings' && name !== 'check'">
                <label class="form-label">{{ $t(name) }}</label>
                <div class="form-value" v-html="accessData(item, i)"></div>
              </v-col>
              <v-col cols="12" v-if="displaySettings" class="text-right">
                <slot name="editFeature" :row="item"></slot>
                <app-table-delete-modal v-if="enableDelete" :tableRecord="item" :serverRoute="serverRoute"
                  @record-deleted="reFetchData(tableOptions.tableMeta.page)" />
              </v-col>
            </v-row>
          </v-card>
        </v-fade-transition>
      </div>
      <div class="d-flex justify-center mt-5" v-if="!tableOptions.loading && displayPagination">
        <app-pagination :totalPages="tableOptions.tableMeta.total" :page="tableOptions.tableMeta.page"
          :perPage="getPerPage()" @PaginationValue="fetchNewPaginated($event)" />
      </div>
    </v-container>
  </div>
</template>
<script>
import spinner from "./spinner.vue";
import pagination from "./pagination.vue";
import tableDeleteModal from "./tableDeleteModal.vue";
import dialogTable from "../../views/dashboard/components/core/dialogTable.vue";
//
export default {
  components: {
    dialogTable,
    appTableDeleteModal: tableDeleteModal,
    appSpinner: spinner,
    appPagination: pagination,
  },
  data() {
    return {
      deleteDialog: false,
      headerList: {},
      selected_all: false,
    };
  },

  props: {
    serverRoute: String,
    enableDelete: {
      type: Boolean,
      default: true,
    },
    flaggedItems: {
      type: Array,
      default() {
        return [];
      },
    },
    displaySettings: {
      type: Boolean,
      default: true,
    },
    displayPagination: {
      type: Boolean,
      default: true,
    },
    tableOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    checkSelected() {
      this.$emit('check-Selected', this.selected_all);
    },
    updateHeaders(newHeaders) {
      this.tableOptions.loading = true;
      this.tableOptions.tableHeaders = [];
      this.tableOptions.accessTableData = [];
      this.headerList = newHeaders;
      newHeaders.text.map((header, i) => {
        if (header.value) {
          this.tableOptions.tableHeaders.push(header.name);
          if (newHeaders.value[i]) {
            this.tableOptions.accessTableData.push(newHeaders.value[i]);
            this.flaggedItems.map((el, j) => {
              if (el[0] == newHeaders.value[i][0]) this.flaggedItems.splice(j, 1);
            })
          }
        } else {
          if (newHeaders.value[i]) this.flaggedItems.push(newHeaders.value[i]);
        }
      });
      this.tableOptions.loading = false;
    },
    getPerPage() {
      if (this.tableOptions.tableMeta.perPage) {
        return this.tableOptions.tableMeta.perPage;
      } else {
        return 10;
      }
    },
    castItems(item) {
      let copyItem = { ...item };
      this.flaggedItems.forEach((el) => {
        delete copyItem[el];
      });
      return copyItem;
    },
    accessData(row, index) {
      return this.fetchAttributes(
        row,
        this.tableOptions.accessTableData[index]
      );
    },
    fetchAttributes(row, nestedKey) {
      let value = row;
      for (let key in nestedKey) {
        if (value[nestedKey[key]]) {
          value = value[nestedKey[key]];
        } else {
          return;
        }
      }
      return this.$i18n.t(value.toLocaleString());
    },
    fetchNewPaginated(paginationValue) {
      this.$emit("re-fetch-paginated-data", paginationValue);
    },
    reFetchData(paginationValue) {
      this.$emit("re-fetch-data", paginationValue);
    },
  },
  created() {
    const text = this.tableOptions.tableHeaders.map((header) => ({
      name: header,
      value: 1,
    }));
    const value = [...this.tableOptions.accessTableData];
    console.log(value);
    this.headerList = {
      text, value,
    }
  }
};
</script>

<style scoped lang="scss">
.heightWidth {
  width: 20%;
}

.table-desktop {
  display: block;
}

.table-mobile {
  display: none;
}

@media (max-width: 960px) {
  .table-desktop {
    display: none;
  }

  .table-mobile {
    display: block;
  }
}

.entry-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  background: #fff;
}

.form-label {
  font-size: 0.95rem;
  font-weight: 600;
  color: #666;
  margin-bottom: 4px;
  display: block;
}

.form-value {
  font-size: 0.85rem;
  padding: 6px 10px;
  border: 1px solid #eee;
  border-radius: 6px;
  background: #fafafa;
}

table {
  border-collapse: collapse;
  table-layout: fixed;
}

#buffet-table {
  font-size: 0.9rem;
}

#buffet-table th {
  color: #909399;
  border: 1px solid rgb(216 216 221 / 53%);
  font-size: 0.9rem;
  text-align: center;
  width: max-content;
}

#buffet-table td {
  border: 1px solid rgb(216 216 221 / 53%);
  text-align: center;
  font-size: 1rem;
  width: max-content;
}
</style>